import {IMGPW} from '@/config';
import {Prize} from '@winelivery-org/wl-client-sdk-js';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {Link} from '../../../../../navigation';
import CatalogItem from './CatalogItem';

interface Props {
  prizes: Array<Prize>;
  isAuth: boolean;
}

const Catalog = (props: Props): JSX.Element => {
  const t = useTranslations('loyalty');

  if (props.prizes.length === 0 || !props.prizes) {
    return (
      <div className="tw-text-center tw-text-lg">
        {t('wallet.shop.nothingToShow')}
      </div>
    );
  }

  return (
    <section className="tw-container tw-mx-auto tw-px-4 lg:tw-px-6 xl:tw-px-8">
      <ul className="tw-grid sm:tw-grid-cols-2 md:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4 md:tw-gap-6 tw-pl-0">
        <Link href={'/experience'} className="tw-no-underline tw-h-full">
          <article className="tw-flex tw-flex-col tw-h-full tw-group">
            <div className="tw-relative tw-w-full tw-aspect-square tw-mb-2">
              <Image
                fill
                src={IMGPW + '/visita_cantine.jpg'}
                alt={'Visita cantine'}
                className="tw-rounded-lg"
              />
            </div>
            <div>
              <h2 className="tw-text-lg tw-mb-0 tw-font-bold group-hover:tw-underline tw-underline-offset-2">
                {t('wallet.shop.redeemExperience')}
              </h2>
            </div>
          </article>
        </Link>
        {props.prizes.map(({id, points, imageUrl, name}, idx) => {
          return (
            <li key={idx} className="tw-h-full">
              <Link
                href={{pathname: '/wallet/prize/[id]', params: {id}}}
                className="tw-no-underline tw-h-full"
              >
                <CatalogItem
                  id={id}
                  imageUrl={imageUrl}
                  name={name}
                  points={points}
                  isAuth={props.isAuth}
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
export default Catalog;
